export default __webpack_public_path__ + "static/media/pink-ball-inverted.718cc609.svg";